<template>
<div class="collabsable-section">
    <!--Header-->
    <div class="section-title clickable-header" @click="toggleExpanded()">
        <div class="markups-symbols"></div>
        <div style="flex-grow: 1; font-size: 17px">Symbols</div>
        <div style="color: gray" class="expand-collapse-ico fas" :class="!isExpanded ? 'fa-caret-down' : 'fa-caret-up'"></div>
    </div>
    <!--Expander-->
    <div v-if="isExpanded" class="expanded-section">
        <!--Folders List-->
        <AdminSymbolsFolder :key="folder.id" :folder="folder"></AdminSymbolsFolder>
        <!--Confirmation Messages-->
        <div class="info-section" style="align-items: center">
            <input type="file" webkitdirectory multiple style="display: none" id="browsePointCloudFile" @change="onPointCloudFileChanged($event)" />
            <progress style="width: 50%; height: 20px" v-if="isUploadingPointCloud" min="0" :max="maxProgress" step="1" :value="progress"></progress>
            <div v-if="isUploadingPointCloud">
                {{ progress }}/{{ maxProgress }} Files
                {{ isDeleting ? "Deleted" : "Uploaded" }}
            </div>
            <div style="display: flex; width: 100%; justify-content: center">
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { toggleExpandComponent } from "../../../../scripts/js/forgeviewer";
import { getAllMarkupSymbols, saveMarkupSymbol } from "../../../../utils/mongoUtils";
const ForgeMarkupSymbol = window.ForgeMarkupSymbol;
export default {
    name: "AdminSymbols",
    components: {
        AdminSymbolsFolder: () => import("./adminSymbolsFolder.vue"),
    },
    props: ["assetid"],
    data() {
        return {
            isExpanded: false,
            isUploadingPointCloud: false,
            progress: 0,
            maxProgress: 100,
            isDeleting: false,
            searchText: "",
            folderPath: "",
            itemsTree: [],
            folder:[],
        };
    },
    async mounted() {
        var allMarkupSymbols = await getAllMarkupSymbols();
        this.$store.commit('setMarkupSymbols' ,allMarkupSymbols);
        this.itemsTree = this.getSymbolsTree(allMarkupSymbols);
        this.folders = this.itemsTree.folders;
        this.folder = {
            name: 'Symbols',
            symbols: this.itemsTree.symbols,
            folders:this.folders,
            path: '',
            id: this.$store.state.forgeService.newGuid(),
        };
    },
    methods: {
        addNewSymbol(folder) {
            var _this = this;
            this.$store.dispatch({
                type: "prompt_Forge_Extended",
                title: "Add new Symbol",
                callback: (inputs) => {
                    var name = inputs[0].trim();
                    var svgText = inputs[1];
                    var symbol = new ForgeMarkupSymbol();
                    symbol.name = name;
                    symbol.createdOn = new Date().toDateString();
                    symbol.userId = _this.$store.state.username;
                    symbol.createdBy = _this.$store.state.username;
                    symbol.svgText = svgText;
                    symbol.folderPath = _this.folderPath;
                    saveMarkupSymbol(symbol);
                    _this.getCurrentNode().symbols.push(symbol);
                },
                input: {
                    inputName: "Name",
                    inputValue: "",
                },
                extendedInput: {
                    inputName: "SVG Text",
                    inputValue: "",
                },
            });
        },
        getSymbolsTree(symbols) {
            let tree = {
                name: "",
                symbols: [],
                folders: [],
            };
            for (let symbol of symbols) {
                if (!symbol.folderPath) tree.symbols.push(symbol);
                else {
                    let folders = symbol.folderPath.split("/");
                    let folderToAddInto = tree;
                    let path = "";
                    for (let name of folders) {
                        path += path ? "/" + name : name;
                        let folder = folderToAddInto.folders.find((o) => o.name == name);
                        if (!folder) {
                            folder = {
                                name: name,
                                symbols: [],
                                folders: [],
                                path: path,
                                id: this.$store.state.forgeService.newGuid(),
                            };
                            folderToAddInto.folders.push(folder);
                        }
                        folderToAddInto = folder;
                    }
                    folderToAddInto.symbols.push(symbol);
                }
            }
            return tree;
        },
        getCurrentNode() {
            let node = this.itemsTree;
            if (!this.folderPath) return node;
            let folders = this.folderPath.split("/");
            for (let folder of folders) {
                node = node.folders.find((o) => o.name == folder);
            }
            return node;
        },
        toggleExpandedFolder(path) {
            var _this = this;
            if (_this.folderPath === path) {
                //Navigate up
                var lastSlash = path.lastIndexOf("/");
                var parentPath = path.slice(0, lastSlash);
                _this.folderPath = parentPath;
            } else {
                _this.folderPath = path;
            }
        },
        toggleExpanded() {
            toggleExpandComponent(this);
        }
    },
};
</script>

<style>
.markups-symbols {
    background-size: cover;
    background-image: url(../../../../images/markupTools/symbol.svg);
    width: 23px;
    height: 23px;
    margin-right: 10px;
}
</style>
